/* Natur Total: automatic homepage widget loading, without a second activation
 * button. This does not grant or override Shopify tracking consent.
 * Before public use without consent, confirm the provider's cookie-free
 * configuration and review its external fonts, services and privacy notices.
 */
(() => {
  'use strict';
  if (customElements.get('nt-review-auto')) return;
  const platformUrl = 'https://elfsightcdn.com/platform.js';
  class NTReviewAuto extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.status = this.querySelector('[data-review-status]');
      this.widget = this.querySelector('[data-review-widget]');
      if (!this.status || !this.widget) return;
      this.observer = new MutationObserver(() => this.checkRendered());
      this.observer.observe(this.widget, {childList:true, subtree:true, attributes:true});
      this.timeout = window.setTimeout(() => this.showError(), 20000);
      const existing = Array.from(document.scripts).find((script) =>
        script.src === platformUrl || script.src === 'https://static.elfsight.com/platform/platform.js'
      );
      if (existing) {
        existing.addEventListener('error', () => this.showError(), {once:true});
        this.checkRendered();
        return;
      }
      const script = document.createElement('script');
      script.src = platformUrl;
      script.async = true;
      script.dataset.ntReviewsAutoloader = 'true';
      script.addEventListener('error', () => this.showError(), {once:true});
      document.head.appendChild(script);
    }
    checkRendered() {
      if (!this.isConnected || !this.widget) return false;
      if (this.widget.children.length > 0 && this.widget.getBoundingClientRect().height > 50) {
        this.status.hidden = true;
        this.observer?.disconnect();
        window.clearTimeout(this.timeout);
        return true;
      }
      return false;
    }
    showError() {
      if (!this.isConnected || this.checkRendered()) return;
      this.status.textContent = this.dataset.errorText;
      this.status.hidden = false;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.clearTimeout(this.timeout);
      this.initialized = false;
    }
  }
  customElements.define('nt-review-auto', NTReviewAuto);
})();
